export default __webpack_public_path__ + "static/media/main-logo.5250fb6a.svg";